import { render, staticRenderFns } from "./CartCollapse.vue?vue&type=template&id=dad2c370&scoped=true&"
import script from "./CartCollapse.vue?vue&type=script&lang=js&"
export * from "./CartCollapse.vue?vue&type=script&lang=js&"
import style0 from "./CartCollapse.vue?vue&type=style&index=0&id=dad2c370&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad2c370",
  null
  
)

export default component.exports